import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCabinet: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCabinet"><Path d="M2.5 4.5V11.5H21.5V4.5H2.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M12 5V11" stroke="currentColor"/><Path d="M4.75 11.75L3.5 19.5" stroke="currentColor" strokeLinecap="square"/><Path d="M19.25 11.75L20.5 19.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconCabinet;
